import { createSlice } from '@reduxjs/toolkit';

import type { AuditoriaState } from '../../types';
import { fetchConversaAuditoria } from './actions';

const initialState: AuditoriaState = {
  activeRequestId: null,
  conversaId: null,
  items: [],
  nextCursor: null,
  hasMore: false,
  isLoading: false,
  isLoadingMore: false,
  error: null,
};

const auditoriaSlice = createSlice({
  name: 'chatAtendimentoAuditoria',
  initialState,
  reducers: {
    clearAuditoria(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConversaAuditoria.pending, (state, action) => {
        const append = Boolean(action.meta.arg.append);
        state.error = null;
        state.activeRequestId = action.meta.requestId;
        if (append) {
          state.isLoadingMore = true;
        } else {
          state.isLoading = true;
          state.conversaId = action.meta.arg.conversaId;
          state.items = [];
          state.nextCursor = null;
          state.hasMore = false;
        }
      })
      .addCase(fetchConversaAuditoria.fulfilled, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) return;
        state.activeRequestId = null;
        state.isLoading = false;
        state.isLoadingMore = false;
        state.conversaId = action.payload.conversaId;
        state.items = action.payload.append
          ? [...state.items, ...action.payload.items]
          : action.payload.items;
        state.nextCursor = action.payload.nextCursor;
        state.hasMore = action.payload.hasMore;
      })
      .addCase(fetchConversaAuditoria.rejected, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) return;
        state.activeRequestId = null;
        state.isLoading = false;
        state.isLoadingMore = false;
        state.error = action.payload ?? 'Erro ao carregar auditoria';
      });
  },
});

export const { clearAuditoria } = auditoriaSlice.actions;
export const auditoriaReducer = auditoriaSlice.reducer;
